<template>
  <b-modal
    title="ایجاد کوپن جدید"
    id="modal-coupon-add"
    no-close-on-backdrop
    centered
    ok-title="ایجاد"
    cancel-title="انصراف"
    @cancel="closeModal"
    @ok.prevent="sendCouponCreateRequest"
  >
    <b-container fluid>
      <b-form-row>
        <b-col :cols="isLessonCoupon ? 6 : 12">
          <course-picker
            @getCourse="setCourseId"
            @getCoursePrice="setCoursePrice"
          ></course-picker>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group
            label="نوع کوپن را انتخاب کنید"
            label-for="coupon-types"
          >
            <b-form-select
              size="sm"
              id="coupon-types"
              :options="couponTypes"
              v-model="couponDetails.type"
              placeholder="نوع کوپن"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group :label="couponValueLabel" label-for="discount-type">
            <b-form-input
              type="number"
              size="sm"
              id="discount-type"
              :formatter="formatCouponValue"
              v-model="computedCouponValue"
              :placeholder="couponValuePlaceholder"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="تاریخ شروع کوپن" label-for="couponStart">
            <b-form-input
              class="startDate"
              size="sm"
              id="couponStart"
              placeholder="تاریخ شروع کوپن را وارد کنید"
            ></b-form-input>
            <date-picker
              v-model="couponDetails.startDate"
              class="absolute"
              customInput=".startDate"
              display-format="jYYYY/jMM/jDD"
              input-format="jYYYY/jMM/jDD"
              format="YYYY-MM-DD"
            ></date-picker>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="تاریخ پایان کوپن" label-for="couponEnd">
            <b-form-input
              class="endDate"
              size="sm"
              id="couponEnd"
              placeholder="تاریخ پایان کوپن را وارد کنید"
            ></b-form-input>
            <date-picker
              v-model="couponDetails.endDate"
              class="absolute"
              customInput=".endDate"
              display-format="jYYYY/jMM/jDD"
              input-format="jYYYY/jMM/jDD"
              format="YYYY-MM-DD"
            ></date-picker>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group
            label="نوع اجرای کوپن را انتخاب کنید"
            label-for="execution-types"
          >
            <b-form-select
              size="sm"
              id="execution-types"
              :options="executionTypes"
              v-model="couponDetails.execution"
              placeholder="نوع اجرای کوپن"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group
            label="تعداد قابل استفاده کوپن"
            label-for="discount-quantity"
          >
            <b-form-input
              type="number"
              size="sm"
              id="discount-quantity"
              v-model="couponDetails.baseQuantity"
              placeholder="در صورت بی نهایت بودن خالی بگذارید"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" v-if="couponDetails.execution == 2">
          <user-picker @getUser="setUserId"></user-picker>
        </b-col>
        <b-col cols="12">
          <b-form-group label="کد کوپن" label-for="discount-code">
            <b-form-input
              size="sm"
              id="discount-code"
              v-model="couponDetails.code"
              placeholder="کد اختصاصی کوپن را وارد کنید"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="6" v-if="isLessonCoupon">
          <lesson-picker
            :isDisabled="!tempCourseId"
            :defaultCourseId="tempCourseId"
            @getLesson="setLessonId"
          ></lesson-picker>
        </b-col>
      </b-form-row>
    </b-container>
  </b-modal>
</template>

<script>
import CoursePicker from "../MasterActiveCourse/CoursePicker.vue";
import LessonPicker from "../Lessons/LessonPicker.vue";
import UserPicker from "../Users/UserPicker.vue";
import { CreateCoupon } from "@/libs/Api/Coupon";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  BModal,
  BContainer,
  BRow,
  BCol,
  BFormRow,
  BFormGroup,
  BFormInput,
  BFormSelect,
} from "bootstrap-vue";
export default {
  props: {
    discountFor: {
      type: String,
      default: "course",
      validator(value) {
        // The value must match one of these strings
        return ["course", "lesson"].includes(value);
      },
    },
  },
  data() {
    return {
      couponTypes: [
        {
          text: "کوپن درصدی",
          value: 1,
        },
        {
          text: "کوپن عددی",
          value: 2,
        },
      ],
      executionTypes: [
        {
          text: "عمومی",
          value: 1,
        },
        {
          text: "شخصی",
          value: 2,
        },
      ],
      //   Types: {
      //     1: ByPercentage,
      //     2: ByDigit,
      //   }

      //   Execution: {
      //     Quantity: 1,
      //     UserId: 2,
      //   }
      couponDetails: {
        isDeleted: false,
        couponId: 0,
        type: 1,
        couponValue: null,
        startDate: new Date(Date.now()),
        endDate: null,
        courseId: null,
        lessonId: null,
        execution: 1,
        baseQuantity: null,
        maintainedQuantity: null,
        userId: null,
        hasUsedByUser: null,
        code: null,
        createDate: new Date(Date.now()),
      },
      tempCourseId: null,
      tempCoursePrice: null,
    };
  },
  methods: {
    async sendCouponCreateRequest() {
      try {
        this.couponDetails.startDate = new Date(this.couponDetails.startDate);
        this.couponDetails.endDate = new Date(this.couponDetails.endDate);
        this.couponDetails.maintainedQuantity = this.couponDetails.baseQuantity;
        let _this = this;
        let createCoupon = new CreateCoupon(_this);
        createCoupon.setRequestParamDataObj(_this.couponDetails);
        await createCoupon.fetch((response) => {
          if (response) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "کوپن با موفقیت ایجاد شد",
                icon: "CheckIcon",
                variant: "success",
              },
            });
            _this.closeModal();
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
    setLessonId(lessonId) {
      this.couponDetails.lessonId = lessonId;
    },
    setCoursePrice(price) {
      this.tempCoursePrice = price;
    },
    formatCouponValue(value) {
      if (value > this.couponMaxValue) {
        return this.couponMaxValue;
      }
      return value;
    },
    setCourseId(courseId) {
      this.tempCourseId = courseId;
      if (!this.isLessonDiscount) {
        this.couponDetails.courseId = courseId;
      }
    },
    setUserId(userId) {
      this.couponDetails.userId = userId;
    },
    closeModal() {
      this.$bvModal.hide("modal-coupon-add");
    },
  },
  computed: {
    couponValueLabel() {
      if (this.couponDetails.type == 2) {
        return "مقدار کوپن (تومان)";
      } else if (this.couponDetails.type == 1) {
        return "مقدار کوپن (درصد)";
      }
    },
    couponMaxValue() {
      if (this.couponDetails.type == 2) {
        return this.tempCoursePrice;
      } else if (this.couponDetails.type == 1) {
        return 100;
      }
    },
    computedCouponValue: {
      set(val) {
        this.couponDetails.couponValue = val;
      },
      get() {
        return this.couponDetails.couponValue;
      },
    },
    couponValuePlaceholder() {
      if (this.couponDetails.type == 2) {
        return "مقدار کوپن را به تومان وارد کنید";
      } else if (this.couponDetails.type == 1) {
        return "مقدار درصد کوپن را وارد کنید";
      }
    },
    isLessonCoupon() {
      if (this.discountFor == "lesson") {
        return true;
      }
      return false;
    },
  },
  components: {
    UserPicker,
    CoursePicker,
    LessonPicker,
    BModal,
    BContainer,
    BRow,
    BCol,
    BFormRow,
    BFormGroup,
    BFormInput,
    BFormSelect,
  },
};
</script>
